import React from 'react';
import { Box, Paper, Typography } from '@mui/material';
import { useTokens } from 'theme';

/** Bento panel: a light header row (icon, title, action) over the body. */
export default function Panel({ icon, title, action, children, bodySx, ...paperProps }) {
  const t = useTokens();
  return (
    <Paper sx={{ p: 0, overflow: 'hidden', height: '100%', display: 'flex', flexDirection: 'column' }} {...paperProps}>
      <Box
        sx={{
          borderBottom: `1px solid ${t.border}`,
          px: 2.5,
          py: 1.25,
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          minHeight: 44,
        }}
      >
        {icon && React.cloneElement(icon, { sx: { fontSize: 16, color: t.iconMuted } })}
        <Typography sx={{ fontSize: '0.9rem', fontWeight: 700, color: t.ink }}>
          {title}
        </Typography>
        <Box sx={{ flexGrow: 1 }} />
        {action}
      </Box>
      <Box sx={{ p: 2.5, flexGrow: 1, ...bodySx }}>{children}</Box>
    </Paper>
  );
}
